import logo from './logo.svg';
import './App.css';

import React, { useEffect, useState } from 'react';

import Admin from './Admin';
import * as API from './api/api';
import Register from './Register';
import User from './User';

function App() {

  const [userToken, setUserToken] = useState(localStorage.getItem('userToken'));
  const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken'));

  return (
    <div className="App">
        <div id="content">

          { !userToken && <Register /> }
          { userToken && adminToken && ( <Admin /> ) }
          { userToken && !adminToken && ( <User /> ) }
          
        </div>
    </div>
  );
}

export default App;
